import type { insuranceImportApiSpec } from "@wingspanhq/wingspan-api-types";
import { IInsuranceCoverageImportData } from "@wingspanhq/benefits/dist/src/lib/interfaces";
import {
  IInsuranceCoverageFieldCheckResult,
  validateInsuranceCoverageImportData
} from "@wingspanhq/benefits/dist/src/lib/helpers/policyValidation";

export const getPolicies = (
  extractionJob: insuranceImportApiSpec.InsuranceImportJob,
  onlyValid?: boolean
) => {
  const extractedFields = extractionJob.extractedFields;

  const policies = extractedFields?.policies || [];

  return policies
    .map(_policy => {
      const policy = _policy as any;

      const importData: IInsuranceCoverageImportData = {
        ...policy, // add whatever we could extract and validate
        namedInsured: extractedFields!.namedInsured,
        certificateHolder: extractedFields!.certificateHolder,
        descriptionOfOperations: extractedFields!.descriptionOfOperations,
        issuingOrganization: extractedFields!.issuingOrganization
      };

      return importData;
    })
    .filter(policy => {
      if (onlyValid) {
        return validateInsuranceCoverageImportData(policy).length === 0;
      }

      return true;
    });
};
export const getIssues = (
  extractionJob: insuranceImportApiSpec.InsuranceImportJob
) => {
  let issues: IInsuranceCoverageFieldCheckResult[] = [];
  const policies = getPolicies(extractionJob);

  policies?.forEach(policy => {
    issues = [...issues, ...validateInsuranceCoverageImportData(policy)];
  });

  return issues;
};
